module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": "Sites By Landord",
      "table-ref": "landlordstable2",
      "url": 'report/property/renewals/' + this.rowData.id,
      "show-search": false,
      "sort-field": "siteName",
      "search-placeholder": "Search Site Name...",
      "fields": _vm.fields,
      "track-by": "id",
      "detail-component": "property-details"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8ad020"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyLandlordDetail.vue
// module id = 1474
// module chunks = 0